import {
  Box,
  Button,
  Typography,
  Alert,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { SalesLogType } from "../../common/enums/SalesLogEnums";
import { useState } from "react";

export default function SaleTypeSelectionPage({ onNext }) {
  const [selectedType, setSelectedType] = useState(null);
  const [error, setError] = useState(null);

  const handleNext = () => {
    if (!selectedType) {
      setError("Please select a transaction type to continue");
      return;
    }
    setError(null);
    onNext(selectedType);
  };

  const saleTypes = SalesLogType.getAllValues();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        p: 3,
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 600 }}>
        <Typography variant="h2" gutterBottom>
          Start New Sales Checkout
        </Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          Choose the transaction type you want to create.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <FormControl component="fieldset" fullWidth sx={{ mb: 3 }}>
          <FormLabel component="legend" sx={{ mb: 1 }}>
            Transaction Type
          </FormLabel>
          <RadioGroup
            value={selectedType || ""}
            onChange={(e) => {
              setSelectedType(e.target.value);
              setError(null);
            }}
          >
            {saleTypes.map((type) => (
              <FormControlLabel
                key={type}
                value={type}
                control={<Radio />}
                label={SalesLogType.getDisplayText(type)}
              />
            ))}
          </RadioGroup>
        </FormControl>

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            size="large"
            onClick={handleNext}
            disabled={!selectedType}
          >
            Next
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
